import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-nb-weight',
  template: `
  <div class="row">
<div class="col-4 d-flex align-items-center">
    <label for="input" class="form-label
    ">{{ to.label }}</label>
</div>
  <div class="col-8 mb-2">
    <div class="d-flex align-items-center">
      <input nbInput class="mr-2" fullWidth [type]="type" [status]="(formControl.errors && formControl.touched)? 'danger' : 'basic'" [(ngModel)]="displayValue" [formlyAttributes]="field" (ngModelChange)="onInputChange($event)">
    <label *ngIf="to.unit">{{ to.unit }}</label>
    </div>
    <p class="text-danger" *ngIf="formControl.errors?.required && formControl.touched">{{to.label}} is required.</p>
  </div>
</div>
  `,
})
export class FormlyFieldNbWeight extends FieldType implements OnInit {
  type: string = 'number';
  displayValue: number | null = null; // This will hold the display value

  ngOnInit() {
    this.to.unit = this.options.formState.customData.isImperial ? 'lbs' : 'kg';
    // Initialize displayValue based on the formControl value
    this.displayValue = this.options.formState.customData.isImperial ? this.convertKgToLbs(this.formControl.value) : this.formControl.value;
  }

  onInputChange(value: string) {
    let numericValue = parseFloat(value);
    // Convert the display value back to kg before setting it to the form control
    if (this.options.formState.customData.isImperial) {
      this.formControl.setValue(this.convertLbsToKg(numericValue));
    } else {
      this.formControl.setValue(numericValue);
    }
  }

  convertKgToLbs(kg: number): number {
    return +((kg * 2.20462).toFixed(2));
  }

  convertLbsToKg(lbs: number): number {
    return +((lbs / 2.20462).toFixed(2));
  }
}
